import React from 'react';

import MainScreenReport from '../MainScreenReport/MainScreenReport';
import {
  botTopics,
  screenType,
  botPages,
  botsSubPages,
} from '../MainScreenReport/index';
import Footer from '../../../../components/Footer2';

const INITIAL_CURRENT_PAGE_STATE_VALUE = {
  page: botPages.BOT,
  subPage: botsSubPages.BOT_NUMBER_OF_CLIENTS,
  // page: botPages.MESSAGE_HISTORY,
  // subPage: '',
};

/**
 * Bot report main screen component, container for the entire screen
 *
 * @param {*} props
 * @returns
 */
const BotReportMainScreen = () => {
  return (
    <>
      <MainScreenReport
        topics={botTopics}
        reportScreenType={screenType.BOT}
        currentPageInitialState={INITIAL_CURRENT_PAGE_STATE_VALUE}
      />
      <Footer />
    </>
  );
};

export default BotReportMainScreen;
